document.addEventListener('click', function (event) {
  var button = event.target.closest('.size-chart__unit-btn');
  if (!button) return;

  var chart = button.closest('.product__size-chart');
  if (!chart) return;

  var unit = button.getAttribute('data-unit');
  if (!unit) return;

  chart.classList.remove('unit-in', 'unit-cm');
  chart.classList.add('unit-' + unit);

  chart.querySelectorAll('.size-chart__unit-btn').forEach(function (btn) {
    btn.classList.toggle('is-active', btn === button);
  });
});

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-pill-toggle]');
  if (!toggle) return;

  var container = toggle.closest('[data-features]');
  if (!container) return;

  var expanded = container.classList.toggle('is-expanded');
  toggle.textContent = expanded
    ? toggle.getAttribute('data-less-label')
    : toggle.getAttribute('data-more-label');
});

/* Size chart layout: the raw size-guide table has one inch column and one cm
   column per size, with each size heading spanning both (colspan="2"). The CSS
   hides whichever unit isn't selected, so here each size heading is set to span
   a single column, and the old <colgroup> (which relied on
   visibility: collapse, not honored everywhere) is removed. The result is one
   clean column per size that fits the width of the chart. */
function corsaNormalizeSizeCharts(root) {
  (root || document).querySelectorAll('.product__size-chart table').forEach(function (table) {
    if (table.dataset.corsaNormalized) return;
    table.dataset.corsaNormalized = 'true';

    var colgroup = table.querySelector('colgroup');
    if (colgroup) colgroup.remove();

    var firstRow = table.querySelector('tr');
    if (!firstRow) return;
    Array.prototype.forEach.call(firstRow.children, function (cell) {
      if (cell.colSpan > 1) cell.colSpan = 1;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    corsaNormalizeSizeCharts();
  });
} else {
  corsaNormalizeSizeCharts();
}

if (window.MutationObserver) {
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        corsaNormalizeSizeCharts();
        break;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
}

/* "How to measure" pop-up */
document.addEventListener('click', function (event) {
  var opener = event.target.closest('[data-measure-open]');
  if (opener) {
    var dialog = document.getElementById(opener.getAttribute('data-measure-open'));
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
      document.documentElement.classList.add('corsa-measure-open');
    }
    return;
  }

  var closer = event.target.closest('[data-measure-close]');
  if (closer) {
    var openDialog = closer.closest('dialog');
    if (openDialog) openDialog.close();
    return;
  }

  /* Clicking the dimmed area around the pop-up closes it. */
  if (event.target.matches && event.target.matches('dialog.corsa-measure')) {
    var rect = event.target.getBoundingClientRect();
    var inside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!inside) event.target.close();
  }
});

document.addEventListener(
  'close',
  function (event) {
    if (event.target.matches && event.target.matches('dialog.corsa-measure')) {
      document.documentElement.classList.remove('corsa-measure-open');
    }
  },
  true
);
